export const PREMIUM_UPSELL_WIDGET_SHOWN_STORAGE_KEY =
  'premium-upsell-widget-shown';
export const PREMIUM_ASIA_UPSELL_WIDGET_SHOWN_STORAGE_KEY =
  'premium-asia-upsell-widget-shown';
export const PREMIUM_TILT_UPSELL_WIDGET_SHOWN_STORAGE_KEY =
  'premium-tilt-upsell-widget-shown';

export type PremiumUpsellStorageKey =
  | typeof PREMIUM_UPSELL_WIDGET_SHOWN_STORAGE_KEY
  | typeof PREMIUM_ASIA_UPSELL_WIDGET_SHOWN_STORAGE_KEY
  | typeof PREMIUM_TILT_UPSELL_WIDGET_SHOWN_STORAGE_KEY;
